import styled from 'styled-components';
import {POPUP_MOBILE_PADDING_INLINE, POPUP_PADDING_INLINE} from '../../../pages/team/about/About.css';
import {getGridArea} from '../../../functions/cssFenctions';
import {BLACK, DARK_GRAY2, DEFAULT_COLOR, mobileMedia, scrollbar} from '../../../globalVariables/GlobalVariables';
import {titleWrap, wrapInput} from '../../../component/input/basicInput/BasicInput.css';
import * as input from '../../../component/classes/input';
import {icon} from '../../../component/input/inputList/InputList.css';
import zIndex from '../../../globalVariables/zIndex';
import {alignStretch, dFlex, dFlexColumn, dInlineFlex, flexNoWrap, flexWrap, justifyBetween, justifyEnd} from '../../../globalVariables/GlobalFlex';
import {popUpContent} from '../../../component/popUp/PopUp.css';
import {charNum} from '../../../component/input/textareaInput/TextareaInput.css';

export const  popUp= styled.div`
    ${popUpContent}{
        overflow-y: auto;
        ${mobileMedia}{
            height: calc(100% - 180px);
        }
    }
`;
export const header = styled.div`
    ${dFlex}
    ${justifyBetween}
    ${alignStretch}
    width: calc(100% - 75px);
    height: 60px;
    padding-block: 20px;
    margin: -60px 50px auto 50px;
    z-index: ${zIndex.baseRaised};
    font-size: 16px;
    ${mobileMedia}{
        margin-top: 0;
    }
`;
export const container=styled.div<{ formType?: string }>` 
    margin: 20px ${POPUP_PADDING_INLINE};
    display: grid;
    grid-template-areas: "title video"
                        "description description"
                        "distributions page";
    column-gap: 4%;
    row-gap: 15px;
    grid-template-columns: 48% 48%;
    ${getGridArea(['title','video','distributions','page'])}
    ${mobileMedia}{
            ${dFlexColumn}
            padding-inline:${POPUP_MOBILE_PADDING_INLINE};
            margin-inline: 0;
            >div{
                margin-top: 10px;
            }
    }
    .message {     
        ${dFlexColumn}
        height: 150px;
        ${wrapInput}, textarea, div[class*=container] {
            height: 100%;
        }
    }
`;
export const descriptionWrapper = styled.div<{$hasValue?: boolean}>`
    grid-area: description;
    textarea {
        border: 0.5px solid ${BLACK};
        border-radius: 5px;
        height: 78px;
    }
    ${charNum} {
        position: static;
        margin-inline-start: ${p=>p.$hasValue? 50:0}px;
        transition: all 200ms;
    }
    ${titleWrap}{
        top: ${p=>p.$hasValue? 18:-60}px;
    }
`;

export const distributions = styled.div``;
export const howToDisplay = styled.div`
    grid-area: howToDisplay;
    ${dInlineFlex}
`;
export const roleSelectInput = styled(input.container)`
    padding-bottom: 0;
    margin-top: -8px;
    ${icon} {
        width: 0;
    }
`;
export const rolesContainer = styled.div`
        position: absolute;
        inset-inline-end: 20px;
        top: 15px;
        ${dInlineFlex}
        max-width: 100%;
        ${flexWrap}
`;
export const selectedPageContainer = styled(rolesContainer)`
    max-width: calc(100% - 95px);
    overflow-x: auto;
    overflow-y: hidden;
    top: 20px;
    ${flexNoWrap}
    ${scrollbar}
`;
export const bottom = styled.div`
    ${dFlex}
    ${justifyEnd}
    padding: 3%;
    border-top: 1px solid ${DARK_GRAY2};
    div:first-child{
        margin-inline-end: 15px;
    }
`;

export const selectedPageType = styled.div`
    padding: 3px 9px 5px 8px;
    border-radius: 55px;
    border: 0.5px solid ${DEFAULT_COLOR};
    cursor: pointer;
    font-size: 10px;
    margin-inline: 2px;
    min-width: fit-content
`;